import { render, staticRenderFns } from "./TargetVerificationFile.vue?vue&type=template&id=4f52da23&scoped=true&"
import script from "./TargetVerificationFile.vue?vue&type=script&lang=js&"
export * from "./TargetVerificationFile.vue?vue&type=script&lang=js&"
import style0 from "./TargetVerificationFile.vue?vue&type=style&index=0&id=4f52da23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f52da23",
  null
  
)

export default component.exports